var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 1.75C7.73772 1.75 7.8867 1.8115 7.99609 1.9209L12.7129 6.63867C13.3459 7.27566 13.3458 8.30344 12.7129 8.94043L12.7119 8.94238L8.94727 12.7061C8.64096 13.0127 8.22534 13.1855 7.79199 13.1855C7.35887 13.1854 6.94294 13.0133 6.63672 12.707L1.9209 7.99609C1.81151 7.8867 1.75 7.73772 1.75 7.58301V2.33301C1.75018 2.0111 2.0111 1.75018 2.33301 1.75H7.58301ZM2.91699 7.34082L7.46191 11.8818C7.54937 11.9693 7.66832 12.0184 7.79199 12.0186C7.91574 12.0185 8.03464 11.9693 8.12207 11.8818L11.8867 8.11719C12.0661 7.93515 12.0659 7.64247 11.8857 7.46094L7.3418 2.91699H2.91699V7.34082ZM5.39551 4.66699C5.7981 4.66699 6.12482 4.99295 6.125 5.39551C6.125 5.79821 5.79821 6.125 5.39551 6.125C4.99295 6.12482 4.66699 5.7981 4.66699 5.39551C4.66717 4.99306 4.99306 4.66717 5.39551 4.66699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoTag);
export default __webpack_public_path__ + "static/media/promo-tag.286e079106f7410aa9fde2146c46a134.svg";
export { ForwardRef as ReactComponent };